import { z } from 'zod';
export const API_VERSION = 'v1';
export const API_PREFIX = `/${API_VERSION}`;
export const TENANT_HEADER = 'x-tenant-id';
export const ERROR_CODES = {
    ACTION_POLICY_BLOCKED: 'ACTION_POLICY_BLOCKED',
    AGENT_RUNTIME_CATALOG_UNAVAILABLE: 'AGENT_RUNTIME_CATALOG_UNAVAILABLE',
    AGENT_RUNTIME_UNAVAILABLE: 'AGENT_RUNTIME_UNAVAILABLE',
    ARTIFACT_ALREADY_EXISTS: 'ARTIFACT_ALREADY_EXISTS',
    CONFLICT: 'CONFLICT',
    CREDENTIAL_RECOVERY_REQUIRED: 'CREDENTIAL_RECOVERY_REQUIRED',
    DATABASE_ERROR: 'DATABASE_ERROR',
    FORBIDDEN: 'FORBIDDEN',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    INTEGRATION_UPSTREAM_FAILED: 'INTEGRATION_UPSTREAM_FAILED',
    INVALID_CALLBACK: 'INVALID_CALLBACK',
    INVALID_OAUTH_STATE: 'INVALID_OAUTH_STATE',
    INVALID_TENANT_CONTEXT: 'INVALID_TENANT_CONTEXT',
    MCP_ACCESS_INACTIVE: 'MCP_ACCESS_INACTIVE',
    MCP_QUOTA_EXCEEDED: 'MCP_QUOTA_EXCEEDED',
    MRM_CONNECTION_REQUIRED: 'MRM_CONNECTION_REQUIRED',
    NOT_FOUND: 'NOT_FOUND',
    NOTIFICATION_CHANNEL_UNAVAILABLE: 'NOTIFICATION_CHANNEL_UNAVAILABLE',
    OAUTH_CALLBACK_FAILED: 'OAUTH_CALLBACK_FAILED',
    OAUTH_NOT_CONFIGURED: 'OAUTH_NOT_CONFIGURED',
    OAUTH_REJECTED: 'OAUTH_REJECTED',
    RATE_LIMITED: 'RATE_LIMITED',
    PERSONAL_ACCESS_TOKEN_QUOTA_EXCEEDED: 'PERSONAL_ACCESS_TOKEN_QUOTA_EXCEEDED',
    PERSONAL_ACCESS_TOKEN_SCOPE_REQUIRED: 'PERSONAL_ACCESS_TOKEN_SCOPE_REQUIRED',
    PERSONAL_ACCESS_TOKEN_TENANT_MISMATCH: 'PERSONAL_ACCESS_TOKEN_TENANT_MISMATCH',
    RETRY_NOT_ALLOWED: 'RETRY_NOT_ALLOWED',
    UNAUTHORIZED: 'UNAUTHORIZED',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    VERSION_CONFLICT: 'VERSION_CONFLICT',
    VOICE_INPUT_DISABLED: 'VOICE_INPUT_DISABLED',
};
export const errorCodeSchema = z.enum(Object.values(ERROR_CODES));
export const apiErrorEnvelopeSchema = z.object({
    error: z.object({
        code: errorCodeSchema,
        message: z.string(),
        details: z.unknown().optional(),
        issues: z.array(z.unknown()).optional(),
    }),
});
//# sourceMappingURL=api.js.map